import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { Observable } from 'rxjs';
import { ElectricityCompany, Response } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class ElectricityCompanyService {
  constructor(private http: HttpClient) { }

  list(): Observable<Response<ElectricityCompany[]>> {
    return this.http.post<Response<ElectricityCompany[]>>(environment.apiUrl + '/api/ElectricityCompany/List', {});
  }
}
